<template>
  <div>
    <!-- <div class="mainTitle">机构管理</div> v-auth="'/agentInfo/pageList'"-->
    <el-card class="box-card" v-auth="'/agentInfo/pageList'">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="机构名称" prop="name" class="form-bottom">
              <el-input v-model="searchForm.name" placeholder="请输入机构名称/电话/域名" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="机构等级" prop="distributionLevelIds" class="form-bottom">
              <el-select
                style="width:100%"
                v-model="searchForm.distributionLevelIds"
                multiple
                clearable
                collapse-tags
              >
                <el-option v-for="i in agentLevelList" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="开通时间" prop="createTime" class="form-bottom">
              <el-date-picker style="width: 100%" v-model="createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="timeChange"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6" style="float: right">
            <!-- <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            <el-button
              type="primary"
              @click="addOrganazationVisible = true"
              icon="el-icon-plus"
            >创建机构</el-button>-->
            <el-button-group style="float: right">
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh" v-auth="'/agentInfo/pageListrest'">重置</el-button>
              <el-button type="primary" @click="
                ; (addOrganazationVisible = true),
  getDictionaryTreeByParentId(1)
              " icon="el-icon-plus" v-auth="'/agentInfo/addAgentInfo'">添加机构
              </el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <!-- <el-row :span="24">
        <el-col :span="12">
        <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
        <el-button type="danger" @click="batchDeleteAgentInfo" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button>
        </el-col>
      </el-row>-->
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selectionChange" v-loading="loading">
        <!-- <el-table-column prop="agentLevel.name" label="机构等级" width="120" align="center">
          <template slot-scope="row">
            <span
              v-if="row.row.distributionLevel.indexOf('合伙人')!==-1"
              class="purple"
            >{{row.row.distributionLevel}}</span>
            <span
              v-else-if="row.row.distributionLevel.indexOf('金牌')!==-1"
              class="gold"
            >{{row.row.distributionLevel}}</span>
            <span
              v-else-if="row.row.distributionLevel.indexOf('银牌')!==-1"
              class="gray"
            >{{row.row.distributionLevel}}</span>
            <span
              v-else-if="row.row.distributionLevel.indexOf('铜牌')!==-1"
              class="coppery"
            >{{row.row.agentLevel.name}}</span>
            <span v-else class="general">{{row.row.distributionLevel}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="name" label="机构名称" align="center">
          <template slot-scope="row">
            <el-button type="text" @click="; (selection = row.row.id), getDictionaryTreeByParentId(2)">{{ row.row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="mobile" label="联系手机" align="center"></el-table-column>
        <!-- <el-table-column prop="creditAmount" label="信用额度(元)" align="center"></el-table-column> -->
        <el-table-column prop="amount" label="机构余额(元)" align="center">
          <template slot-scope="row">
            <el-button type="text" @click="; (selection = row.row.id), getAgentInfo(2)">{{ row.row.amount }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="剩余容量/开通容量(G)" align="center">
          <template slot-scope="row">
            <el-button type="text">{{ ((row.row.videoCapacity?row.row.videoCapacity:0) / 1024 / 1024 / 1024 -( row.row.usedCapacity?row.row.usedCapacity:0) / 1024 / 1024 / 1024).toFixed(2) }}/{{ (row.row.videoCapacity / 1024 / 1024 / 1024).toFixed(2) }}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="consumptionAmount" label="消费(元)"></el-table-column> -->
        <el-table-column prop="serviceEndTime" label="有效期至" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.validPeriod == 0">无限期</span>
            <span v-else>{{ scope.row.serviceEndTime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="serviceBeginTime" label="服务开始时间"></el-table-column> -->
        <el-table-column prop="enabled" label="状态" align="center" width="100" :render-header="renderSpecNameHeader">
          <template slot-scope="row">
            <el-switch v-model="row.row.enabled" active-value="1" inactive-value="0" @change="updateSwitchingAgentInfo(row)" class="switchStyle" active-text="开" inactive-text="关"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" v-auth="'/agentInfo/showAgentAmountLog'">
              <i title="查看" class="el-icon-view mainColor" style="font-size: 20px" @click="; (selection = scope.row.id), showAgentAmountLog()"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="!loading" background :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-drawer title="机构详情" :visible.sync="drawer" direction="rtl" size="50%">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 20px; background: #fff">
        <el-tab-pane label="机构信息" name="first">
          <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-col :span="24">
                  <el-form-item label="机构名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入名称" auto-complete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="有效期限" prop="validPeriod">
                    <el-radio-group v-model="editForm.validPeriod">
                      <el-radio style="width: 80px" :label="0">不限有效期</el-radio>
                      <el-radio style="width: 40px" :label="1">1年</el-radio>
                      <el-radio style="width: 40px" :label="2">2年</el-radio>
                      <el-radio style="width: 40px" :label="3">3年</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="扣款方式" prop="deductionType">
                    <el-radio-group v-model="editForm.deductionType">
                      <el-radio style="width: 94px" :label="1">机构账户扣款</el-radio>
                      <el-radio style="width: 94px" :label="3">机构校区账户扣款</el-radio>
                    </el-radio-group>
                    <div></div>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="机构代表" prop="linkman">
                    <el-input placeholder="请输入机构代表" v-model="editForm.linkman"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="机构等级" prop="levelId">
                    <el-select v-model="editForm.levelId" placeholder="请选择" style="width: 100%">
                      <el-option v-for="item in agentLevelList" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                  <el-form-item label="信用额度" prop="creditAmount">
                    <el-input
                      style="width:100%"
                      v-model="editForm.creditAmount"
                      placeholder="请输入信用额度"
                      auto-complete="off"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col> -->
              </el-col>
              <el-col :span="12">
                <el-col :span="24">
                  <el-form-item label="联系电话" prop="mobile">
                    <el-input v-model="editForm.mobile" placeholder="请输入联系电话" auto-complete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="地区">
                    <el-cascader style="width: 100%" clearable v-model="dictionaryIds" :show-all-levels="false" :props="dictionaryProps" placeholder="请选择分类" :options="dictionaryIdList"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="联系地址" prop="address">
                    <el-input type="textarea" v-model="editForm.address" placeholder="请输入联系地址" auto-complete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label>
                <el-button @click="drawer = false">取消</el-button>
                <el-button type="primary" :loading="updateAgentInfoBlock" @click="updateAgentInfo">提交
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-tab-pane>
        <!-- <el-tab-pane label="域名设置" name="second">
          <el-form
            ref="oemForm"
            :label-width="formLabelWidth"
            :rules="domainRules"
          >
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="域名" prop="name">
                  <el-input
                    v-model="oemDomain"
                    placeholder="请输入域名"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label>
                <el-button
                  type="primary"
                  :loading="updateAgentInfoBlock"
                  @click="updateAgentDomain"
                  >提交
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-tab-pane> -->
        <el-tab-pane label="余额充值" name="third">
          <el-row style="margin-left: 20px">
            <el-col :span="12">
              余额(元)
              <div style="font-size: 20px; margin-top: 10px">
                {{ agentInfoAmount.amount }}
              </div>
            </el-col>
            <el-col :span="12">
              消费(元)
              <div style="font-size: 20px; margin-top: 10px">
                {{ agentInfoAmount.consumptionAmount }}
              </div>
            </el-col>
          </el-row>
          <el-form :label-width="formLabelWidth" :model="addAgentAmount" :rules="addAgentAmountRules" ref="addAgentAmount">
            <el-row :gutter="20">
              <el-col :sm="24" :md="12" :lg="12">
                <el-form-item label="操作类型">
                  <el-radio v-model="addAgentAmount.type" label="充值">充值</el-radio>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :sm="24" :md="12" :lg="12">
                <el-form-item label="充值金额" prop="amount">
                  <!-- <el-radio style="width: 190px" v-model="addAgentAmount.amount" v-for="(item, index) in rechargeRuleList" :key="index" :label="item.deductionAmount">
                    {{ item.rechargeAmount }}(实际到账{{
                      item.deductionAmount
                    }})
                  </el-radio> -->
                  <el-input v-model="addAgentAmount.amount" type="number" placeholder="请输入充值金额">
                    <span slot="append">元</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :md="24" :lg="24">
                <el-form-item label="充值凭证">
                  <el-upload ref="upload" action="" :http-request="amountFileUploadRequest" :on-remove="amountHandleRemove" list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20"></el-row>
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label>
                <el-button type="primary" :loading="addAgentAmountLogBlock" @click="addAgentAmountLog">提交
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="容量充值" name="capacity">
          <el-row style="margin-left: 20px">
            <el-col :span="12">
              剩余容量(G)
              <div style="font-size: 20px; margin-top: 10px">
                {{ (editForm.videoCapacity / 1024 / 1024 / 1024 - editForm.usedCapacity / 1024 / 1024 / 1024).toFixed(2) }}
              </div>
            </el-col>
            <el-col :span="12">
              已开通容量(G)
              <div style="font-size: 20px; margin-top: 10px">
                {{ editForm.videoCapacity / 1024 / 1024 / 1024 }}
              </div>
            </el-col>
          </el-row>
          <el-form :label-width="formLabelWidth">
            <el-row :gutter="20" style="margin-top:20px;">
              <el-col :sm="24" :md="24" :lg="24">
                <el-form-item label="充值容量" prop="capacity">
                  <div class="capacityBox">
                    <div class="capacityItem" v-for="(item, idx) in capacityArr" :key="idx" @click="capacityIdx = idx">
                      <div class="checkRect" v-if="idx == capacityIdx">
                        <i class="el-icon-check"></i>
                      </div>
                      <div class="t1">新增容量: {{ item.capacity }}G</div>
                      <div class="t2">¥ {{ item.money }}元</div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :md="24" :lg="24">
                <el-form-item label="充值凭证">
                  <el-upload ref="upload" action="" :http-request="capacityFileUploadRequest" :on-remove="capacityHandleRemove" list-type="picture-card">
                    <i slot="default" class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20"></el-row>
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label>
                <el-button type="primary" :loading="addCapacityLoading" @click="addCapacity">提交
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="充值记录" name="fourth">
          <el-row>
            <el-col :span="12">
              总消费金额
              <div style="font-size: 20px; margin-top: 10px">
                {{ agentInfoAmount.consumptionAmount }}
              </div>
            </el-col>
            <el-col :span="12">
              总充值金额
              <div style="font-size: 20px; margin-top: 10px">
                {{ agentInfoAmount.rechargeAmount }}
              </div>
            </el-col>
          </el-row>
          <el-table ref="multipleTable" :data="userInfoPage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" v-loading="userInfoPageLoading" border>
            <el-table-column show-overflow-tooltip prop="createTime" label="充值时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="userName" label="充值机构"></el-table-column>
            <el-table-column show-overflow-tooltip prop="amount" label="充值金额(元)">
              <template slot-scope="row">
                <span v-if="row.row.amount >= 0">{{ row.row.amount }}</span>
                <span v-else style="color: red">{{ row.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="operatorName" label="操作人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="充值凭证">
              <template slot-scope="row">
                <div v-if="
                  row.row.attachmentList != null &&
                  row.row.attachmentList.length > 0
                ">
                  <div>
                    <el-button type="text" @click="onPreview(row)" class="img">查看</el-button>
                    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="urlList" />
                  </div>
                </div>
                <div v-else>{{ row.row.remark }}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px; text-align: right" :total="userInfoPage.total" :page-size="userInfoPage.pageSize" :current-page="userInfoPage.pageNumber" @size-change="userInfoSizeChange" @current-change="userInfoCurrentChange"></el-pagination>
        </el-tab-pane>
        <!-- <el-tab-pane label="下属代理" name="four">
          <el-button
            type="primary"
            @click="agentUserInfoAddForm.agentId=selection,addFormVisible = true,organizationsChange()"
            icon="el-icon-plus"
          >添加下属代理</el-button>
          <el-table
            ref="multipleTable"
            :data="agentUserInfoPage.rows"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%;"
            border
            v-loading="agentUserInfoPageLoading"
          >
            <el-table-column prop="enabled" label="状态" width="100" align="center">
              <template slot-scope="row">
                <el-switch
                  v-model="row.row.enabled"
                  @change="updateSwitching(row)"
                  active-value="1"
                  inactive-value="0"
                  class="switchStyle"
                  active-text="开"
                  inactive-text="关"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="account" label="手机"></el-table-column>
            <el-table-column prop="amount" label="账户余额(元)"></el-table-column>
            <el-table-column prop label="操作" width="80" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <i
                    class="iconfont iconbianji mainColor"
                    title="编辑"
                    @click="agentUserInfoSelection = scope.row.id, editFormVisible = true,getAgentUserInfo()"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px;text-align: right;"
            :total="agentUserInfoPage.total"
            :page-size="agentUserInfoPage.pageSize"
            :current-page="agentUserInfoPage.pageNumber"
            @size-change="agentUserInfoSizeChange"
            @current-change="agentUserInfoCurrentChange"
          ></el-pagination>
        </el-tab-pane> -->
      </el-tabs>
    </el-drawer>
    <el-dialog title="创建机构" :visible.sync="addOrganazationVisible" width="800px" left>
      <el-form ref="addOrganazationForm" :model="addOrganazationForm" :label-width="formLabelWidth" :rules="addOrganazationFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="24">
              <el-form-item label="机构名称" prop="name">
                <el-input v-model="addOrganazationForm.name" placeholder="请输入名称" auto-complete="off" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="有效期限" prop="validPeriod">
                <el-radio style="width: 80px" v-model="addOrganazationForm.validPeriod" :label="0">不限有效期</el-radio>
                <el-radio style="width: 45px" v-model="addOrganazationForm.validPeriod" :label="1">1年</el-radio>
                <el-radio style="width: 45px" v-model="addOrganazationForm.validPeriod" :label="2">2年</el-radio>
                <el-radio style="width: 45px" v-model="addOrganazationForm.validPeriod" :label="3">3年</el-radio>
                <div></div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="扣款方式" prop="deductionType">
                <el-radio-group v-model="addOrganazationForm.deductionType">
                  <el-radio style="width: 94px" :label="1">机构账户扣款</el-radio>
                  <el-radio style="width: 94px" :label="3">机构校区账户扣款</el-radio>
                </el-radio-group>
                <div></div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="机构代表" prop="linkman">
                <el-input placeholder="请输入机构代表" v-model="addOrganazationForm.linkman" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <!-- 机构等级下拉 addOrganazationForm.levelId -->
            <el-col :span="24">
              <el-form-item label="机构等级" prop="levelId">
                <el-select v-model="addOrganazationForm.levelId" placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in agentLevelList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="24">
              <el-form-item label="信用额度" prop="creditAmount">
                <el-input
                  style="width:100%"
                  v-model="addOrganazationForm.creditAmount"
                  placeholder="请输入信用额度"
                  auto-complete="off"
                  maxlength="11"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col> -->
          </el-col>
          <el-col :span="12">
            <el-col :span="24">
              <el-col :span="24"> </el-col>
              <el-col :span="24">
                <el-form-item label="联系电话" prop="mobile">
                  <el-input v-model="addOrganazationForm.mobile" placeholder="请输入联系电话" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="地区">
                  <el-cascader style="width: 100%" clearable v-model="dictionaryIds" :show-all-levels="false" :props="dictionaryProps" placeholder="请选择分类" :options="dictionaryIdList"></el-cascader>
                </el-form-item>
              </el-col>

              <!-- <el-col :span="24">
                <el-form-item label="网站域名" prop="domain">
                  <el-input
                    v-model="addOrganazationForm.domain"
                    placeholder="请输入名称"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="24">
                <el-form-item label="联系地址" prop="address">
                  <el-input type="textarea" v-model="addOrganazationForm.address" placeholder="请输入联系地址" auto-complete="off" maxlength="30"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right; margin-top: 50px">
        <el-button @click="addOrganazationVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addAgentInfoBlock" @click="addAgentInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加下属代理" :visible.sync="addFormVisible" width="800px" left>
      <el-form ref="agentUserInfoAddForm" :model="agentUserInfoAddForm" :label-width="formLabelWidth" :rules="agentUserInfoAddFormRules">
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="所属机构" prop="agentId">
              <el-select style="width: 100%" v-model="agentUserInfoAddForm.agentId" @change="editOrganizationsChange" disabled>
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="机构可分配余额(元)：" label-width="200">{{
                amount
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="人员姓名" prop="name">
              <el-input v-model="agentUserInfoAddForm.name" placeholder="请输入姓名" auto-complete="off" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="账户余额">
              <el-input type="number" v-model="agentUserInfoAddForm.amount" placeholder="请输入金额" auto-complete="off" maxlength="18">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="角色" prop="roleId">
              <el-select style="width: 100%" v-model="agentUserInfoAddForm.roleId">
                <el-option clearable v-for="i in roletions" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入启用 1启用" auto-complete="off" maxlength="10"></el-input> -->
              <el-radio v-model="agentUserInfoAddForm.enabled" label="1">启用</el-radio>
              <el-radio v-model="agentUserInfoAddForm.enabled" label="0">禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="account">
              <el-input v-model="agentUserInfoAddForm.account" placeholder="请输入手机号码" auto-complete="off" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="登录密码" prop="password">
              <el-input v-model="agentUserInfoAddForm.password" placeholder="请输入登录密码" auto-complete="off" maxlength="50" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right; margin-top: 50px">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentUserInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑代理人员" :visible.sync="editFormVisible" width="800px" left>
      <el-form ref="agentUserInfoEditForm" :model="agentUserInfoEditForm" :label-width="formLabelWidth" :rules="agentUserInfoEditFormRules">
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="所属机构" prop="agentId">
              <el-select style="width: 100%" v-model="agentUserInfoEditForm.agentId" @change="editOrganizationsChange" disabled>
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="机构可分配余额(元)：" label-width="200">{{
                amount
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="人员姓名" prop="name">
              <el-input v-model="agentUserInfoEditForm.name" placeholder="请输入姓名" auto-complete="off" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="账户余额">
              <el-input type="number" v-model="agentUserInfoEditForm.amount" placeholder="请输入金额" auto-complete="off" maxlength="18">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="角色" prop="roleId">
              <el-select style="width: 100%" v-model="agentUserInfoEditForm.roleId">
                <el-option clearable v-for="i in roletions" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入启用 1启用" auto-complete="off" maxlength="10"></el-input> -->
              <el-radio v-model="agentUserInfoEditForm.enabled" label="1">启用</el-radio>
              <el-radio v-model="agentUserInfoEditForm.enabled" label="0">禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="account">
              <el-input v-model="agentUserInfoEditForm.account" placeholder="请输入手机号码" auto-complete="off" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="登录密码" prop="password">
              <el-input v-model="agentUserInfoEditForm.password" placeholder="请输入登录密码" auto-complete="off" maxlength="50" show-password disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right; margin-top: 50px">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAgentUserInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadOSS } from "../../upload/upload";
import { getFathersById } from "../common/conmmon"
import md5 from "md5";
import SelectHeader from "./SelectHeader";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: "Index",
  components: { ElImageViewer },
  data () {
    var idNumReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
    var validateDomain = (rule, value, callback) => {
      if (!idNumReg.test(value)) {
        callback(new Error("域名格式有误（www.baidu.com）"));
      } else {
        callback();
      }
    };
    return {
      capacityIdx: 0,
      capacityArr: [{ capacity: '1000', money: '2000' }, { capacity: '5000', money: '8000' }, { capacity: '10000', money: '15000' },],
      addCapacityLoading: false,
      agentLevelList: [],
      oemDomain: "",
      showViewer: false,
      updateAgentInfoBlock: false,
      addAgentInfoBlock: false,
      addAgentAmountLogBlock: false,
      defaultImg: "../../../static/image/defaultImg2.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      amountFileObj: {
        url: process.env.POI_URL + "/agentAmountLog/upload",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      createTime: [],
      addAgentAmount: {
        type: "充值",
        amount: null,
        attachmentList: [],
      },
      dictionaryIds: [], // 地区
      dictionaryIdList: [], // 分类
      dictionaryProps: {
        value: "id",
        label: "name",
        children: "dictionaries"
      },
      agentUserInfoAddForm: {},
      serviceTime: [],
      organazationDetail: {},
      activeName: "first",
      drawer: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      roletions: [],
      urlList: [],
      userInfoPageLoading: true,
      userInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      agentUserInfoPageLoading: true,
      agentUserInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      addFormVisible: false,
      editFormVisible: false,
      addOrganazationVisible: false,
      searchForm: {
        distributionLevelId: "",
        name: "",
        mobile: "",
      },
      addForm: {},
      addFormRules: {},
      domainForm: {},
      editForm: {},
      addOrganazationForm: {
        deductionType: 1,
        name: null,
        linkman: null,
        validPeriod: 0,
        mobile: null,
        logo: null,
        address: null,
        enabled: "1",
        dictionaryId: ""
      },
      commission: null,
      showAvatar: false,
      rechargeRuleList: null,
      addAgentAmountRules: {
        amount: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur",
          },

          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "充值金额小数点后不能超过二位",
          },
        ],
      },
      agentUserInfoAddFormRules: {
        agentId: {
          required: true,
          message: "请选择机构",
          trigger: "change",
        },
        account: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字",
          },
        ],
        validPeriod: {
          required: true,
          message: "请选择有效期限",
          trigger: "change",
        },
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur",
        },
      },
      editFormRules: {
        name: {
          required: true,
          message: "请输入机构名称",
          trigger: "blur",
        },
        distributionLevelId: {
          required: true,
          message: "请选择代理等级",
          trigger: "change",
        },
        validPeriod: {
          required: true,
          message: "请选择有效期限",
          trigger: "change",
        },

        deductionType: {
          required: true,
          message: "请选择扣款方式",
          trigger: "change",
        },
        creditAmount: [
          {
            required: true,
            message: "请输入信用额度",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (this.editForm.creditAmount < 0) {
                callback(new Error("信用额度不能小于0"));
              }
              callback();
            },
          },
        ],
        // serviceTime: {
        //   required: true,
        //   message: "请选择有效期限",
        //   trigger: "change"
        // },
        linkman: {
          required: true,
          message: "请输入机构代表",
          trigger: "blur",
        },
        levelId: {
          required: true,
          message: "请选择机构等级",
          trigger: "change",
        },
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确",
          },
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "change",
        },
        domain: [
          {
            required: true,
            message: "请输入域名",
            trigger: "blur",
          },
          { validator: validateDomain, trigger: "blur" },
        ],
      },
      addOrganazationFormRules: {
        name: {
          required: true,
          message: "请输入机构名称",
          trigger: "blur",
        },
        distributionLevelId: {
          required: true,
          message: "请选择代理等级",
          trigger: "change",
        },

        validPeriod: {
          required: true,
          message: "请选择有效期限",
          trigger: "change",
        },

        deductionType: {
          required: true,
          message: "请选择扣款方式",
          trigger: "change",
        },
        creditAmount: [
          {
            required: true,
            message: "请输入信用额度",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (this.addOrganazationForm.creditAmount < 0) {
                callback(new Error("信用额度不能小于0"));
              }
              callback();
            },
          },
        ],
        // serviceTime: {
        //   required: true,
        //   message: "请选择有效期限",
        //   trigger: "change"
        // },
        linkman: {
          required: true,
          message: "请输入机构代表",
          trigger: "blur",
        },
        levelId: {
          required: true,
          message: "请选择机构等级",
          trigger: "change",
        },
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确",
          },
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "change",
        },
        domain: [
          {
            required: true,
            message: "请输入域名",
            trigger: "blur",
          },
          { validator: validateDomain, trigger: "blur" },
        ],
      },
      domainRules: {
        domain: [
          {
            required: true,
            message: "请输入域名",
            trigger: "blur",
          },
          { validator: validateDomain, trigger: "blur" },
        ],
      },
      agentUserInfoEditFormRules: {
        agentId: {
          required: true,
          message: "请选择机构",
          trigger: "change",
        },
        name: {
          required: true,
          message: "请输入人员姓名",
          trigger: "blur",
        },
        amount: {
          required: true,
          message: "请输入金额",
          trigger: "blur",
        },
        account: {
          required: true,
          message: "请输入手机号码",
          trigger: "blur",
        },
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "change",
        },
        password: {
          required: true,
          message: "请输入登录密码",
          trigger: "blur",
        },
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/agentInfo/upload`,
      fileList: [],
      loading: true,
      selection: "",
      agentUserInfoSelection: "",
      agentUserInfoEditForm: {},
      organizations: [],
      amount: "",
      agentInfoAmount: [],
      agentLevelList: [],
      capacityAttachment: [],
    };
  },
  methods: {
    // 获取字典
    getDictionaryTreeByParentId (type) {
      if (process.env.NODE_ENV === "development") {
        console.log('test')
      }
      this.api.dictionary.getDictionaryTreeByParentId({ id: "1400364792484573186" }).then(res => {
        this.dictionaryIdList = this.getTreeData(res.data)
        if (type === 2) {
          this.getAgentInfo(1);
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getTreeData (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].dictionaries.length === 0) {
          data[i].dictionaries = undefined;
        } else {
          this.getTreeData(data[i].dictionaries);
        }
      }
      return data;
    },
    onPreview (row) {
      this.urlList = [];
      row.row.attachmentList.forEach((e) => {
        this.urlList.push(e.url);
      });
      // this.urlList.push(row.row.attachmentList)
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer () {
      this.showViewer = false;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    userInfoSizeChange (pageSize) {
      this.userInfoPage.pageSize = pageSize;
      this.agentAmountLogPageList();
    },
    userInfoCurrentChange (pageNumber) {
      this.userInfoPage.pageNumber = pageNumber;
      this.agentAmountLogPageList();
    },
    agentUserInfoSizeChange (pageSize) {
      this.agentUserInfoPage.pageSize = pageSize;
      this.agentUserInfoPageList();
    },
    agentUserInfoCurrentChange (pageNumber) {
      this.agentUserInfoPage.pageNumber = pageNumber;
      this.agentUserInfoPageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    capacityFileUploadRequest (file) {
      console.log("file", file);
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "agentInfo").then((result) => {
          let obj = {
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            url: result,
          };
          this.capacityAttachment.push(obj);
        });
      }
    },
    capacityHandleRemove (file) {
      console.log("111", file);
      for (let index in this.capacityAttachment) {
        if (
          file.name == this.capacityAttachment[index].name &&
          file.size == this.capacityAttachment[index].size
        ) {
          this.capacityAttachment.splice(index, 1);
        }
      }
      console.log("11111111", this.capacityAttachment);
    },
    amountFileUploadRequest (file) {
      console.log("file", file);
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "agentInfo").then((result) => {
          let obj = {
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            url: result,
          };
          this.addAgentAmount.attachmentList.push(obj);
        });
      }
    },
    amountHandleRemove (file) {
      console.log("111", file);
      // this.addAgentAmount.attachmentList.forEach(e => {});
      for (let index in this.addAgentAmount.attachmentList) {
        if (
          file.name == this.addAgentAmount.attachmentList[index].name &&
          file.size == this.addAgentAmount.attachmentList[index].size
        ) {
          this.addAgentAmount.attachmentList.splice(index, 1);
        }
      }
      console.log("11111111", this.addAgentAmount.attachmentList);
    },
    amountHandlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    amountHandleDownload (file) {
      console.log(file);
    },
    getAgentInfo (type, cap) {
      this.api.agentInfo
        .getAgentRoleInfoList({ agentId: this.selection })
        .then((result) => {
          this.roletions = result.data;
        });
      if (type === 1) {
        if (!cap) this.activeName = "first";
        this.api.agentInfo
          .getAgentInfo({
            id: this.selection,
          })
          .then((result) => {
            this.editForm = result.data;
            this.editDistributionLevelChange();
            this.dictionaryIds = getFathersById(result.data.dictionaryId, this.dictionaryIdList);
            this.$set(this.editForm, "serviceTime", []);
            this.editForm.enabled = String(this.editForm.enabled);
            if (
              this.editForm.serviceBeginTime != null &&
              this.editForm.serviceBeginTime != ""
            ) {
              this.editForm.serviceTime.push(
                this.editForm.serviceBeginTime,
                this.editForm.serviceEndTime
              );
            } else {
              this.editForm.serviceTime = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if (type === 2) {
        this.activeName = "third";
        this.getAgentInfoRechargeStats();
        this.getRechargeRuleList();
      }
      this.drawer = true;
    },
    showAgentAmountLog () {
      this.activeName = "fourth";
      this.agentAmountLogPageList();
      this.getAgentInfoRechargeStats();
      this.drawer = true;
    },
    amountChange () {
      var ret = /^\d+(\.\d{1,2})?$/;
      this.addAgentAmount.amount;
    },
    renderSpecNameHeader (createElement, { column, $index }) {
      let self = this;

      //该列的绑定数据
      // console.log(column);
      //列号
      // console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left:30px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    //选择框回调
    selectChange (val) {
      this.page.pageNumber = 1;
      this.searchForm.enabled = val;
      this.pageList();
    },
    getRechargeRuleList () {
      this.api.rechargeRule.getRechargeRuleList().then((result) => {
        if (result.success) {
          this.rechargeRuleList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    timeChange () {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    pageList () {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          for (let i in this.page.rows) {
            this.page.rows[i].enabled = String(this.page.rows[i].enabled);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAgentInfo () {
      if (this.addAgentInfoBlock) {
        return false;
      }
      this.$refs.addOrganazationForm.validate((valid) => {
        if (valid) {
          if (this.dictionaryIds && typeof (this.dictionaryIds) !== 'string' && this.dictionaryIds > 0) {
            let len = this.dictionaryIds.length;
            this.addOrganazationForm.dictionaryId = this.dictionaryIds[len - 1];
          }
          if (this.addOrganazationForm.serviceTime) {
            this.addOrganazationForm.serviceBeginTime = this.addOrganazationForm.serviceTime[0];
            this.addOrganazationForm.serviceEndTime = this.addOrganazationForm.serviceTime[1];
          }
          // if(this.addOrganazationForm.domain.indexOf('http://')==0){
          //   this.addOrganazationForm.domain = this.addOrganazationForm.domain.replace('http://','');
          // }else if(this.addOrganazationForm.domain.indexOf('https://')==0){
          //   this.addOrganazationForm.domain = this.addOrganazationForm.domain.replace('https://','');
          // }
          setTimeout(() => {
            this.addAgentInfoBlock = false;
          }, 5000);
          this.addAgentInfoBlock = true;

          this.api.agentInfo
            .addAgentInfo(this.addOrganazationForm)
            .then((result) => {
              if (result.success) {
                this.addOrganazationVisible = false;
                this.pageList();
                this.addAgentInfoBlock = false;
                this.dictionaryIds = []
              } else {
                this.addAgentInfoBlock = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              this.addAgentInfoBlock = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateSwitchingAgentInfo (row) {
      let obj = {
        agentId: row.row.id,
        enabled: row.row.enabled,
      };
      this.api.agentInfo.enabledAgentInfo(obj).then((result) => {
        if (result.success) {
          this.pageList();
        } else {
          this.$message.error(result.message);
          this.pageList();
        }
      });
    },
    updateAgentDomain () {
      if (this.updateAgentInfoBlock) {
        return false;
      }
      this.$refs.oemForm.validate((valid) => {
        if (valid) {
          this.updateAgentInfoBlock = true;
          this.domainForm.agentId = this.selection;
          this.domainForm.domain = this.domain;
          this.api.agentInfo
            .updateAgentDomain(this.domainForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.updateAgentInfoBlock = false;
                this.drawer = false;
                this.pageList();
              } else {
                this.updateAgentInfoBlock = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              this.updateAgentInfoBlock = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    addCapacity () {
      if (this.addCapacityLoading) {
        return false;
      }
      var rongliang = this.capacityArr[this.capacityIdx].capacity
      var money = this.capacityArr[this.capacityIdx].money
      var params = {
        capacity: rongliang * 1024 * 1024 * 1024,
        agentId: this.selection,
        amount: money,
        attachmentList: this.capacityAttachment,
        type: "充值",
      }
      this.api.agentInfo.addCapacityLog(params).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.addCapacityLoading = false;
          this.drawer = false;
          this.pageList();
        } else {
          this.addCapacityLoading = false;
          this.$message.error(result.message);
        }
      }).catch((error) => {
        this.addCapacityLoading = false;
        console.log(error);
      });

    },
    updateAgentInfo () {
      if (this.updateAgentInfoBlock) {
        return false;
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.updateAgentInfoBlock = true;
          if (this.dictionaryIds && typeof (this.dictionaryIds) !== 'string' && this.dictionaryIds.length > 0) {
            let len = this.dictionaryIds.length;
            this.editForm.dictionaryId = this.dictionaryIds[len - 1];
          }
          if (this.editForm.serviceTime) {
            this.editForm.serviceBeginTime = this.editForm.serviceTime[0];
            this.editForm.serviceEndTime = this.editForm.serviceTime[1];
          }
          // if(this.editForm.domain.indexOf('http://')==0){
          //   this.editForm.domain = this.editForm.domain.replace('http://','');
          // }else if(this.editForm.domain.indexOf('https://')==0){
          //   this.editForm.domain = this.editForm.domain.replace('https://','');
          // }
          this.api.agentInfo
            .updateAgentInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.updateAgentInfoBlock = false;
                this.drawer = false;
                this.pageList();
                this.dictionaryIds = [];
              } else {
                this.updateAgentInfoBlock = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              this.updateAgentInfoBlock = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentInfo (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.agentInfo
            .deleteAgentInfo([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    handleRemove (file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange (file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    addAgentInfoFileUploadRequest (file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "agentInfo").then((result) => {
          this.$message.success("上传成功！");
          this.$set(this.addOrganazationForm, "logo", result);
        });
      }
    },
    editAgentInfoFileUploadRequest (file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "agentInfo").then((result) => {
          this.$message.success("上传成功！");
          this.$set(this.editForm, "logo", result);
        });
      }
    },
    batchDeleteAgentInfo () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.agentInfo
            .deleteAgentInfo(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.loading = true;
      this.$refs.searchForm.resetFields();
      this.createTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.agentInfo
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData () {
      this.api.agentInfo
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClick (tab, event) {
      if (tab.name == "first") {
        this.getAgentInfo(1);
      } else if (tab.name == "second") {
        this.getAgentInfoRechargeStats();
        this.getRechargeRuleList();
      } else if (tab.name == "third") {
        this.$refs.upload.clearFiles();
        this.agentAmountLogPageList();
        this.getAgentInfoRechargeStats();
      } else if (tab.name == "fourth") {
        this.agentUserInfoPageList();
        this.agentAmountLogPageList();
      } else if (tab.name == "capacity") {
        this.getAgentInfo(1, 'capacity');
        this.$refs.upload.clearFiles();
      }
    },
    distributionLevelChange () {
      this.agentLevelList.forEach((e) => {
        if (this.addOrganazationForm.distributionLevelId == e.id) {
          this.addOrganazationForm.creditAmount = e.credits;
          this.commission = e.commission;
        }
      });
    },
    editDistributionLevelChange () {
      this.agentLevelList.forEach((e) => {
        if (this.editForm.distributionLevelId == e.id) {
          this.commission = e.commission;
        }
      });
    },
    addAgentAmountLog () {
      if (this.addAgentAmountLogBlock) {
        return false;
      }
      this.$refs.addAgentAmount.validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.addAgentAmountLogBlock = false;
          }, 5000);
          this.addAgentAmountLogBlock = true;
          this.addAgentAmount.agentId = this.selection;
          this.api.agentInfo
            .addAgentAmountLog(this.addAgentAmount)
            .then((result) => {
              if (result.success) {
                this.addAgentAmount.amount = "";
                this.addAgentAmount.remark = "";
                this.addAgentAmount.attachmentList = [];
                // this.$set(this.addAgentAmount, "attachmentList", []);
                this.$refs.upload.clearFiles();
                this.getAgentInfoRechargeStats();
                this.$message.success(result.message);
                this.addAgentAmountLogBlock = false;
                this.drawer = false;
                this.pageList();
              } else {
                this.addAgentAmountLogBlock = false;
                this.$message.error(result.message);
              }
            });
        }
      });
    },
    getAgentInfoRechargeStats () {
      this.api.agentInfo
        .getAgentInfoRechargeStats({ id: this.selection })
        .then((result) => {
          if (result.success) {
            this.agentInfoAmount = result.data;
          }
        });
    },
    agentAmountLogPageList () {
      this.userInfoPage.rows = [];
      let obj = {
        pageNumber: this.userInfoPage.pageNumber,
        pageSize: this.userInfoPage.pageSize,
        agentId: this.selection,
        type: "充值",
      };
      this.api.agentUserInfo.agentAmountLogPageList(obj).then((result) => {
        if (result.success) {
          this.userInfoPage.rows = result.data.records;
          // this.$nextTick(function() {
          //   this.userInfoPage.rows.forEach(e => {
          //     this.$set(e, "urlList", []);
          //     e.attachmentList.forEach(item => {
          //       e.urlList.push(item.url);
          //     });
          //   });
          // });
          // console.log("11111", this.userInfoPage.rows)
          // this.userInfoPage.rows.attachmentList.forEach(e=>{
          //   this.urlList.push(e.url)
          // });
          this.userInfoPage.total = result.data.total;
          this.userInfoPageLoading = false;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    agentUserInfoPageList () {
      let obj = {
        pageNumber: this.agentUserInfoPage.pageNumber,
        pageSize: this.agentUserInfoPage.pageSize,
        agentId: this.selection,
      };
      this.api.agentUserInfo
        .pageList(obj)
        .then((result) => {
          if (result.success) {
            this.agentUserInfoPage.rows = result.data.records;
            this.agentUserInfoPage.total = result.data.total;
            for (let i in this.agentUserInfoPage.rows) {
              this.agentUserInfoPage.rows[i].enabled = String(
                this.agentUserInfoPage.rows[i].enabled
              );
            }
            this.agentUserInfoPageLoading = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAgentUserInfo () {
      this.$refs.agentUserInfoAddForm.validate((valid) => {
        if (valid) {
          this.agentUserInfoAddForm.password = md5(
            this.agentUserInfoAddForm.password
          );
          console.log(
            "this.agentUserInfoAddForm.password",
            this.agentUserInfoAddForm.password
          );
          this.api.agentUserInfo
            .addAgentUserInfo(this.agentUserInfoAddForm)
            .then((result) => {
              this.addFormVisible = false;
              this.agentUserInfoPageList();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateSwitching (row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled,
      };
      this.api.agentUserInfo.enabledUser(obj).then((result) => {
        if (result.success) {
          this.agentUserInfoPageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    getAgentUserInfo () {
      this.api.agentUserInfo
        .getAgentUserInfo({
          id: this.agentUserInfoSelection,
        })
        .then((result) => {
          this.agentUserInfoEditForm = result.data;
          this.agentUserInfoEditForm.enabled = String(
            this.agentUserInfoEditForm.enabled
          );
          this.editOrganizationsChange();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAgentInfoList () {
      this.api.agentUserInfo.getAgentInfoList().then((result) => {
        this.organizations = result.data;
      });
    },
    organizationsChange () {
      this.organizations.forEach((item) => {
        if (this.agentUserInfoAddForm.agentId == item.id) {
          console.log(item.id);
          this.amount = item.amount;
        }
      });
    },
    editOrganizationsChange () {
      this.organizations.forEach((item) => {
        if (this.agentUserInfoEditForm.agentId == item.id) {
          this.amount = item.amount;
        }
      });
    },
    updateAgentUserInfo () {
      this.$refs.agentUserInfoEditForm.validate((valid) => {
        if (valid) {
          //this.agentUserInfoEditForm.password = md5(this.agentUserInfoEditForm.password);
          this.api.agentUserInfo
            .updateAgentUserInfo(this.agentUserInfoEditForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
  },
  computed: {
    reqData () {
      return this.$store.state.user;
    },
  },
  watch: {
    drawer: function (newVal) {
      this.capacityIdx = 0
      if (!newVal) {
        this.editForm = {};
        this.agentUserInfoPageLoading = true;
        this.userInfoPageLoading = true;
        this.addAgentAmount.amount = null;
        this.addAgentAmount.attachmentList = [];
        this.commission = null;
      } else {
      }
    },
    addOrganazationVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addOrganazationForm.resetFields();
        this.addOrganazationForm.logo = "";
        this.addOrganazationForm.serviceTime = [];
        this.commission = null;
      } else {
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.agentUserInfoAddForm.resetFields();
        this.agentUserInfoPageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.agentUserInfoEditForm.resetFields();
        this.agentUserInfoPageList();
      } else {
      }
    },
  },
  mounted () {
    this.pageList();
    // getAgentLevelList () {
    this.api.agentLevel.getAgentLevelList().then((result) => {
      if (result.success) {
        this.agentLevelList = result.data;
      } else {
        this.$message.error(result.message);
      }
    });
    // }
  },
};
</script>
<style scoped>
.agent-backGround {
  background: rgb(242, 242, 242);
  padding-top: 20px;
}

.gold {
  display: block;
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(255, 177, 2);
  border: solid 1px rgb(255, 177, 2);
  text-align: center;
  border-radius: 4px;
  height: 18px;
  line-height: 18px;
  width: 60px;
}

.purple {
  display: block;
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(199, 113, 246);
  border: solid 1px rgb(199, 113, 246);
  text-align: center;
  border-radius: 4px;
  height: 18px;
  line-height: 18px;
  width: 60px;
}

.gray {
  display: block;
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(142, 170, 188);
  border: solid 1px rgb(142, 170, 188);
  text-align: center;
  border-radius: 4px;
  height: 18px;
  line-height: 18px;
  width: 60px;
}

.coppery {
  display: block;
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(186, 120, 126);
  border: solid 1px rgb(186, 120, 126);
  text-align: center;
  border-radius: 4px;
  height: 18px;
  line-height: 18px;
  width: 60px;
}

.line {
  height: 1px;
  background-color: #dcdfe6;
  margin-bottom: 20px;
}

.el-drawer__header> :first-child {
  font-size: 20px;
}

.el-drawer__header {
  margin-bottom: 0px;
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 132px;
  line-height: 132px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 132px;
  display: block;
  border-radius: 4px;
}

.agentInfo-flex {
  display: flex;
  flex-wrap: wrap;
  width: 600px;
}
</style>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}

.upload-div {
  display: flex;
  flex-direction: row;

  .upload-img {
    width: 200px;
    height: 100px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }

  .upload-content {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .content-text {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }

    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}

.capacityBox {
  display: flex;
  width: 100%;

  .capacityItem {
    width: 158px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
    border: 1px solid rgb(187, 187, 187);
    height: 87px;
    position: relative;
    margin-right: 15px;

    .checkRect {
      width: 14px;
      height: 14px;
      background: #1684FC;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: -1px;

      .el-icon-check {
        color: white;
      }
    }

    .t1 {
      font-size: 12px;
      color: rgb(136, 136, 136);
    }

    .t2 {
      font-size: 20px;
      color: rgb(136, 136, 136);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agentInfo/index.vue